import {Injectable, signal} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {BaseEntityService} from './base-entity.service';
import {IUser} from '../../model/user.model';
import {interval, map, Subscription} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UsersService extends BaseEntityService<IUser, number>{
    // Authenticator fields
    authenticatorUrl: string = 'https://authenticator.thekey.tech/';
    countdown = signal(0);
    private countdownSubscription?: Subscription;

    constructor(protected override http: HttpClient) {
        super('users', http);
    }

    updatePassword(data: any) {
        return this.http.put<any>(`${this.resourceUrl}/password`, data, {observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                this.formatFromServer(res.body);
                return res;
            })
        );
    }

    restePasswordLink(data: any) {
        return this.http.put<any>(`${this.resourceUrl}/reset-password-link`, data, {observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                this.formatFromServer(res.body);
                return res;
            })
        );
    }

    getVacationSummary(userId: number | undefined) {
        return this.http.get<any>(`${this.resourceUrl}/vacation/${userId}`, {observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                this.formatFromServer(res.body);
                return res;
            })
        );
    }

    getCelebrations() {
        return this.http.get<any>(`${this.resourceUrl}/celebrations`, {observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                this.formatFromServer(res.body);
                return res;
            })
        );
    }

    getOut() {
        return this.http.get<any>(`${this.resourceUrl}/out`, {observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                this.formatFromServer(res.body);
                return res;
            })
        );
    }

    findAllForManager() {
        return this.http.get<any>(`${this.resourceUrl}/managers`, {observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                this.formatFromServer(res.body);
                return res;
            })
        );
    }

    activateAuthenticator(id: number | undefined) {
        return this.http.post<any>(`${this.resourceUrl}/authenticator/activate`, {id: id});
    }

    createICall() {
        return this.http.get(`${this.resourceUrl}/ical`, {observe: 'response'}).pipe(
            map((res: HttpResponse<any>) => {
                this.formatFromServer(res.body);
                return res;
            })
        );
    }

    /**
     * For TKS authenticator
     * @param login
     */
    public getUserDataForAuthenticator(login: string | undefined) {
        return btoa(JSON.stringify({
            'username': login,
            'server': 'thekeyhr',
            'type': 'efficience',
            'key': 'auth-tks-validator'
        }));
    }

    public startAuthenticatorCountdown(seconds: number): void {
        this.countdown.set(seconds);
        if (this.countdownSubscription) {
            this.countdownSubscription.unsubscribe();
        }
        this.countdownSubscription = interval(1000).subscribe(() => {
            this.countdown.set(this.countdown() - 1);
            if (this.countdown() <= 0 && this.countdownSubscription) {
                this.countdownSubscription.unsubscribe();
            }
        });
    }
}
